import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react'

import { LoadingSpinner } from '../../@paco/components'

import { Log, Pagination } from '../../models'
import ConnectedPaginationBlock from '../Pagination/ConnectedPaginationBlock'
import { generateLogsDateObject } from './helpers'
import LogDateBlock from './subcomponents/LogDateBlock/LogDateBlock'

import './Logs.scss'

export interface LogsProps {
    isLoket?: boolean;
    isLoading?: boolean;
    logs: Log[] | null;
    pagination?: Pagination;
    onPagination?: (page: number) => void;
    className?: string;
}

interface LogsDateObjectProps {
    [key: string]: Log[];
}

const Logs: FC<LogsProps> = ({
    isLoket,
    isLoading = false,
    logs = [],
    pagination,
    onPagination,
    className = '',
}) => {
    const [logsDateObject, setLogsDateObject] = useState<LogsDateObjectProps>({})
    const classNames = `logs-page page ${className}`

    useEffect((): void => {
        if (logs) {
            setLogsDateObject(generateLogsDateObject(logs))
        }
    }, [logs])

    if (isLoading && (! logs || logs.length === 0)) {
        return (
            <div className={classNames}>
                <LoadingSpinner className="logs-page__loading-spinner" />
            </div>
        )
    }

    const renderLogDateBlock = (): ReactElement[] => Object.values(logsDateObject).map(logsInDate => (
        <LogDateBlock
            isLoket={isLoket}
            key={logsInDate[0].id}
            logs={logsInDate}
        />
    ))

    if (! pagination || pagination.pages <= 1) {
        return (
            <div className={classNames}>
                {renderLogDateBlock()}
            </div>
        )
    }

    return (
        <div className={classNames}>
            <ConnectedPaginationBlock
                {...pagination}
                onPagination={onPagination}
                className={className}
            >
                {renderLogDateBlock()}
            </ConnectedPaginationBlock>

            {isLoading && <LoadingSpinner />}
        </div>
    )
}

export default Logs
